import { createStore } from '@reduxjs/toolkit';
import { inputReducer } from './../reducers/inputs';
// import { inputReducer } from './../reducers/testInputs';

export const store = createStore(inputReducer);
